module.exports = __webpack_public_path__ + "6ccfdcaf6f3803e4bfa31917f7b427b3.png";